
module.exports = {
    setTitle: function(title) {
        if(typeof title !== "string") {
            throw new Error("Title should be an string");
        }
        document.title = title;
    }
}